export default {
  users: [],
  totalDataRow:0,
  notifications: []
}
